// extracted by mini-css-extract-plugin
module.exports = {"container":"JobAlertChip_container__5ErCo","chip":"JobAlertChip_chip__EKhU2"};